import { render, staticRenderFns } from "./BotonSlider.vue?vue&type=template&id=117232d8&scoped=true&"
import script from "./BotonSlider.vue?vue&type=script&lang=js&"
export * from "./BotonSlider.vue?vue&type=script&lang=js&"
import style0 from "./BotonSlider.vue?vue&type=style&index=0&id=117232d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117232d8",
  null
  
)

export default component.exports